export const SegmentType = {
    STATIC: 'static',
    AUTO_REFRESH: 'auto_refresh',
};

export const SegmentTypeToLabel = {
    [SegmentType.STATIC]: 'Static',
    [SegmentType.AUTO_REFRESH]: 'Auto-refreshing',
};
